class MegaBall extends React.Component {
  constructor(props) {
    super(props);
    this.loopDigits = this.loopDigits.bind(this);
    this.lotteryCount = this.props.lottery;
  }
  loopDigits(data) {
    let lotteryArray = [];
    for (let index = 1; index <= data; index++) {
      lotteryArray.push(index);
    }
    return lotteryArray;
  }
  render() {
    let data = this.lotteryCount.luckyDigits;

    return (
      <>
        {this.loopDigits(data).map((digit, index) => (
          <div
            className="card__text Mega"
            key={index}
            onClick={this.props.MegaBallDataKey}
            id={`cardTextMega-${index}`}
            title={digit}
          >
            <span id={`spanMega-${index}`}> {digit}</span>
          </div>
        ))}
      </>
    );
  }
}

export default MegaBall;
